import React from 'react';
import {useSWRConfig} from 'swr';
import useGetTalkingPoints from './useGetTalkingPoints';
import {useVoting} from '../providers/voting';
import {VoteEnum} from '../types';
import {GET_TALKING_POINTS_QUERY_KEY} from '../config/misc';

interface Props {
  onSuccess?: () => void;
  onError?: () => void;
}

const useSubmitVote = ({onSuccess, onError}: Props = {}) => {
  const {mutate} = useSWRConfig();
  const {data: talkingPosts} = useGetTalkingPoints();
  const {vote} = useVoting();

  const voteHandler = React.useCallback(
    async (tpId: string, voteType: VoteEnum) => {
      try {
        const currentTp = talkingPosts?.some(tp => tp.id === tpId);
        if (!currentTp || !talkingPosts) {
          throw new Error('talking point not found');
        }
        const newData = talkingPosts.map(tp => {
          if (tp.id === tpId) {
            return {
              ...tp,
              vote: voteType,
            };
          }
          return tp;
        });
        mutate(GET_TALKING_POINTS_QUERY_KEY, newData, false);
        await vote(tpId, voteType);
        mutate(GET_TALKING_POINTS_QUERY_KEY);
        onSuccess?.();
      } catch (error) {
        onError?.();
      }
    },
    [mutate, onError, onSuccess, talkingPosts, vote]
  );

  return voteHandler;
};

export default useSubmitVote;
